import React from 'react'
import * as SurveyJS from 'survey-react'

import PlacesWrapper from './placesWrapper'

const AddressWidget = {
  name: 'addresswidget',
  title: 'addresswidget',
  iconName: 'icon-default',
  widgetIsLoaded: function() {
    return true
  },
  isFit: function(question) {
    const applicableQuestions = [
      'Xplor_ChildAddress',
      'Xplor_PCAddress',
      'Xplor_PCWorkAddress',
      'Xplor_ACAddress',
      'Xplor_ACWorkAddress',
      'Info_EC1Address',
      'Info_EC2Address',
      'Xplor_EC1Address',
      'Xplor_EC2Address'
    ]

    return applicableQuestions.includes(question.name)
  },
  activatedByChanged: function() {
    SurveyJS.JsonObject.metaData.addClass('addresswidget', [], null, 'text')
  },
  // eslint-disable-next-line react/display-name
  render: question => {
    return <PlacesWrapper question={question} />
  }
}

export default AddressWidget
